import { render, staticRenderFns } from "./order.vue?vue&type=template&id=179eda67&scoped=true&"
import script from "./order.vue?vue&type=script&lang=js&"
export * from "./order.vue?vue&type=script&lang=js&"
import style0 from "./order.vue?vue&type=style&index=0&id=179eda67&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179eda67",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('179eda67')) {
      api.createRecord('179eda67', component.options)
    } else {
      api.reload('179eda67', component.options)
    }
    module.hot.accept("./order.vue?vue&type=template&id=179eda67&scoped=true&", function () {
      api.rerender('179eda67', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/seller/components/groupBuying/order.vue"
export default component.exports